import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  createBoardingPassResult,
  createMockData,
  createMockDataWithResponse,
} from '@dapi/sdk/spec';
import {
  inhibitedBoardingPassResult,
  noItemToPayError,
  returnedBoardingPassResult,
} from '../../../mock/data';
import {
  retrieveSeatMapsJourneyDriven,
} from '../common/seatmap';
import {
  journeys,
  partialAcceptedChosenJourney,
} from './journey-logic';

const seatmap = retrieveSeatMapsJourneyDriven(journeys[0], journeys[0].travelers.map((t) => t.id).filter((id): id is string => !!id));

/**
 * Connection Flights
 * 1 Journey - 2 flights -1 ADT
 * Validate Partial Acceptance
 */
export const ow1Journey2Flights1AdtPartialAcceptance: MockMap = {
  generateBoardingPasses: [
    createMockDataWithResponse(combineBoardingPassResults([
      returnedBoardingPassResult[0],
      createBoardingPassResult({
        template: {
          ...inhibitedBoardingPassResult[0],
          journeyElementIds: ['JOURNEY-ELEMENT-1-MOCK']
        }
      })]).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [noItemToPayError])],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201),
    createMockDataWithResponse(partialAcceptedChosenJourney, 201)],
  retrieveJourney: [
    createMockData(partialAcceptedChosenJourney)
  ],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([partialAcceptedChosenJourney], 201)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
